/* Case-sensitive forms (OpenType "case") only where the text is capitals or figures.
   Suisse Intl moves dashes and brackets onto the centre of capitals and figures with "case";
   in running text those same marks must stay centred on lowercase letters, so a global rule
   would be wrong. This wraps only:
   - a dash or hyphen between two capitals/figures ("25,4 – 31,8 mm", "0 – 15 °C", "SK-CZ")
   - brackets whose content has no lowercase letter ("(L1 + L5)", "(MP3)", "(2026)")
   in <span class="case-forms">. Cond and uppercase text get "case" from CSS and are skipped. */
(function () {
  var SKIP = 'script,style,noscript,textarea,input,select,option,code,pre,svg,[contenteditable],' +
    '.suisse-intl-condensed-medium,.suisse-intl-condensed-bold,.text-uppercase,.case-forms,.case-off,' +
    '[class*="suisse-intl-mono"],.product-specs';
  var DASH = /([\p{Lu}\d°%])(\s?)([–—-])(\s?)(?=[\p{Lu}\d−+])/gu;
  var BRACKETS = /\(([^()\p{Ll}]*[\p{Lu}\d][^()\p{Ll}]*)\)/gu;
  var QUICK = /[–—\-(]/;

  function wrap(text) {
    var marks = [];
    text.replace(DASH, function (m, a, s1, d, s2, i) { marks.push(i + a.length + s1.length); return m; });
    text.replace(BRACKETS, function (m, inner, i) { marks.push(i, i + m.length - 1); return m; });
    return marks.sort(function (x, y) { return x - y; });
  }

  function run(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!QUICK.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        return p && !p.closest(SKIP) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var t = n.nodeValue, marks = wrap(t);
      if (!marks.length) return;
      var frag = document.createDocumentFragment(), last = 0;
      marks.forEach(function (i) {
        if (i > last) frag.appendChild(document.createTextNode(t.slice(last, i)));
        var s = document.createElement('span');
        s.className = 'case-forms';
        s.textContent = t.charAt(i);
        frag.appendChild(s);
        last = i + 1;
      });
      if (last < t.length) frag.appendChild(document.createTextNode(t.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  function init() { run(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
